import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IApp } from '../../stores/AllStores';
import { Layout, Pages } from './../../components/layout';
import { EAdminPages } from '../../../../common/interfaces/admin';
import { UsersList, Configuration } from '.';

// Component
@inject('store')
@observer
class AdminMain extends React.Component<IApp, {}> {
    constructor(props) {
        super(props);

        // Set default admin page
        this.props.store.admin.changePage(EAdminPages.Users);
    }

    public render() {
        const { admin } = this.props.store;

        return (
            <Layout>
                <Pages>
                    {(admin.page === EAdminPages.Users && <UsersList key="users-list" />) ||
                        (admin.page === EAdminPages.Config && <Configuration key="configuration" />)}
                </Pages>
            </Layout>
        );
    }
}

export default AdminMain;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/admin/AdminMain.tsx